<template>
    <div>
        <h2 class="headline-s form-headline-dealer-app">Additional Information</h2>
        <div class="field-type-dealer-app">
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder input-date">
                    <date-picker :aria-required="true" v-model="customer_date_founded" name="customer_date_founded" autocomplete="false" aria-label="Company Founded On" label="Company Founded On *" />
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.customer_date_founded">{{ errors.customer_date_founded }}</p></div>
            </div>
            <div class="field-state-dealer-app">
                <custom-select
                    :aria-required="true"
                    v-model="selectedCustomerEmployeeOption"
                    label="Companies Total Employees *"
                    name="customer_employees" 
                    id="customer_employees" 
                    aria-label="Enter Total Employees"
                    :options="formattedCustomerEmployeesOptions"
                    :error="errors.customer_employees != null"
                />
                <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.customer_employees">{{ errors.customer_employees }}</p></div>
            </div>
            <div class="input-row-dealer-app">
                <div class="field-state-dealer-app" v-if="!props.hideSource">
                    <custom-select
                        :aria-required="true"
                        v-model="selectedHowDidYouHearAboutRothcoOption"
                        label="How did you hear about Rothco? *"
                        name="how_did_you_hear_about_rothco" 
                        id="how_did_you_hear_about_rothco" 
                        aria-label="Enter How you heared about Rothco"
                        :options="formattedHowDidYouHearAboutRothcoOptions"
                        :error="errors.how_did_you_hear_about_rothco != null"
                    />
                    <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.how_did_you_hear_about_rothco">{{ errors.how_did_you_hear_about_rothco }}</p></div>
                </div>
                <div v-if="['trade_organization', 'trade_show', 'social'].includes(how_did_you_hear_about_rothco) && !props.hideSource" class="field-state-dealer-app">
                    <custom-select                    
                        :aria-required="true"
                        v-model="selectedHowDidYouHearAboutRothcoDetailsOption"
                        label="Please Specify *"
                        name="how_did_you_hear_about_rothco_details" 
                        id="how_did_you_hear_about_rothco_details" 
                        aria-label="Please Specify"
                        :options="howDidYouHearAboutRothcoDetailsOptions"
                        :error="errors.how_did_you_hear_about_rothco_details != null"
                    />
                    <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.how_did_you_hear_about_rothco_details">{{ errors.how_did_you_hear_about_rothco_details }}</p></div>
                </div>
            </div>
            <div class="field-state-dealer-app">
                <custom-select
                    :aria-required="true"
                    v-model="selectedTotalAnnualSaleOption"
                    label="Company Total Annual Sales *"
                    name="total_annual_sale" 
                    id="total_annual_sale" 
                    aria-label="Enter Total Annual Sale"
                    :options="formattedTotalAnnualSaleOptions"
                    :error="errors.total_annual_sale != null"
                />
                <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.total_annual_sale">{{ errors.total_annual_sale }}</p></div>
            </div>

            <div class="input-row-dealer-app">
                <div class="field-state-dealer-app">
                    <custom-select
                        :aria-required="true"
                        v-model="selectedTotalOutsideSaleOption"
                        label="Company Total Sales Outside the US *"
                        name="total_outside_sale" 
                        id="total_outside_sale" 
                        aria-label="Enter Total Outside Sale"
                        :options="formattedTotalOutsideSaleOptions"
                        :error="errors.total_outside_sale != null"
                    />
                    <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.total_outside_sale">{{ errors.total_outside_sale }}</p></div>
                </div>
                <div class="field-state-dealer-app">
                    <custom-select
                        :aria-required="requireSaleOnOtherCountries"
                        v-model:selected-options="saleOnOtherCountries"
                        :label="`Other Countries Sold To ${requireSaleOnOtherCountries ? '*' : ''}`"
                        name="outside_countries" 
                        id="outside_countries" 
                        aria-label="Select Other Countries Sold To"
                        multiple
                        :options="formattedOutsideCountries"
                        :error="errors.sale_on_other_countries != null"
                    />
                    <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.sale_on_other_countries">{{ errors.sale_on_other_countries }}</p></div>
                </div>
            </div>
            <div class="field-state-dealer-app" style="display: flex; flex-direction: column;">
                <custom-select v-model:selected-options="topVendors" multiple allow-more :upTo="3" label="Top Vendors" allow-more-placeholder="Enter Vendor Name (limit 3)" emptyMessage="Please type up to 3 of your top vendors and press enter" :error="errors.top_vendor_1"></custom-select>
                <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.top_vendor_1">{{ errors.top_vendor_1 }}</p></div>
            </div>
            <div class="field-state-dealer-app">
                <div class="textarea-folder">
                    <textarea :aria-required="true" id="describe_end_user" v-model="describe_end_user" placeholder=" " :class="{'input-folder--input': true, 'invalid-state-input': errors.describe_end_user != null}"></textarea>
                    <label class="paragraph-default" for="describe_end_user">Please Take a Brief Moment to Describe Your End User *</label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.describe_end_user">{{ errors.describe_end_user }}</p></div>
            </div>
            <div class="field-state-dealer-app">
                <div class="textarea-folder">
                    <textarea :aria-required="true" id="urls_featuring_rothco_text-area" v-model="urls_featuring_rothco" placeholder=" " :class="{'input-folder--input': true, 'invalid-state-input': errors.urls_featuring_rothco != null}"></textarea>
                    <label class="paragraph-default" for="urls_featuring_rothco_text-area">Please List All URLS Where You Plan on Featuring Rothco.</label>
                </div>
                <div class="input-folder">
                    <p class="input-support-text paragraph-default" v-if="!errors.urls_featuring_rothco">
                        Please Note Rothco Does Not Accept Any 3rd Party Sellers.
                    </p>
                    <p class="input-support-text invalid-state" v-else-if="errors.urls_featuring_rothco">{{ errors.urls_featuring_rothco }}</p></div>
            </div>
            <div v-if="dealer_type == 'brick_mortar'" class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputText 
                        :aria-required="true"
                        id="total_stores" v-model="total_stores"
                        :class="{'invalid-state-input': errors.total_stores != null}"
                        placeholder=" "
                        fluid
                    />
                    <label for="total_stores" :class="{'invalid-state': errors.total_stores}">
                        <p>Total Number of Stores *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.total_stores">{{ errors.total_stores }}</p></div>
            </div>
            <div class="field-state-dealer-app" v-if="dealer_type == 'promotional'">
                <p>Do you screenprint, embroider or logo the products you sell? *</p>
                <div class="flex flex-row" style="gap: 0 2rem;">
                    <label for="screenprint_embroider_logo_yes">
                        <input type="radio" id="screenprint_embroider_logo_yes" name="screenprint_embroider_logo" value="1" v-model="screenprint_embroider_logo" aria-label="screenprint embroider logo yes"> Yes
                    </label>
                    <label for="screenprint_embroider_logo_no">
                        <input type="radio" id="screenprint_embroider_logo_no" name="screenprint_embroider_logo" value="0" v-model="screenprint_embroider_logo" aria-label="screenprint embroider logo no"> No
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.screenprint_embroider_logo">{{ errors.screenprint_embroider_logo }}</p></div>
            </div>
        </div>
        <div class="field-type-dealer-app-full-width">
            <div v-if="dealer_type == 'government'" class="field-state-dealer-app">
                <custom-select
                    v-model="selectedNumberOfGovContractsOption"
                    label="Please Indicate the Number of Government Contracts You Have Successfully Fulfilled *"
                    name="number_of_gov_contracts" 
                    id="number_of_gov_contracts" 
                    aria-label="Select Number of Government Contracts"
                    :options="formattedNumberOfGovContractsOptions"
                    :error="errors.number_of_gov_contracts != null"
                />
                <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.number_of_gov_contracts">{{ errors.number_of_gov_contracts }}</p></div>
            </div>
            <div class="field-state-dealer-app" v-if="dealer_type == 'government'">
                <div class="textarea-folder">
                    <textarea id="gov_websites_text-area" v-model="gov_websites" placeholder=" " :class="{'input-folder--input': true, 'invalid-state-input': errors.gov_websites != null}"></textarea>
                    <label class="paragraph-default" for="gov_websites_text-area">List any Government Websites on Which You Offer Product</label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.gov_websites">{{ errors.gov_websites }}</p></div>
            </div>
        </div>
        <div v-if="dealer_type == 'government'">
            <h3 class="headline-xs form-headline-dealer-app">Percentage of Business Done on the Following Levels: *</h3>
            <div class="field-type-dealer-app">
                <div class="field-state-dealer-app">
                    <div class="input-folder" style="padding-top: 0.5rem">
                        <div class="input-folder--input">
                            <InputText 
                                :aria-required="true"
                                id="customer_business_federal" v-model="customer_business_federal"
                                :class="{'invalid-state-input': errors.customer_business_federal != null}"
                                placeholder=" "
                                fluid
                            />
                            <label for="customer_business_federal" :class="{'invalid-state': errors.customer_business_federal}">
                                <p>Federal *</p>
                            </label>
                        </div>
                        <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.customer_business_federal">{{ errors.customer_business_federal }}</p></div>
                    </div>
                </div>
                <div class="field-state-dealer-app">
                    <div class="input-folder" style="padding-top: 0.5rem">
                        <div class="input-folder--input">
                            <InputText 
                                :aria-required="true" 
                                id="customer_business_state" v-model="customer_business_state"
                                :class="{'invalid-state-input': errors.customer_business_state != null}"
                                placeholder=" "
                                fluid
                            />
                            <label for="customer_business_state" :class="{'invalid-state': errors.customer_business_state}">
                                <p>State *</p>
                            </label>
                        </div>
                        <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.customer_business_state">{{ errors.customer_business_state }}</p></div>
                    </div>
                </div>
                <div class="field-state-dealer-app">
                    <div class="input-folder" style="padding-top: 0.5rem">
                        <div class="input-folder--input">
                            <InputText 
                                :aria-required="true" 
                                id="customer_business_local" v-model="customer_business_local"
                                :class="{'invalid-state-input': errors.customer_business_local != null}"
                                placeholder=" "
                                fluid
                            />
                            <label for="customer_business_local" :class="{'invalid-state': errors.customer_business_local}">
                                <p>Local *</p>
                            </label>
                        </div>
                        <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.customer_business_local">{{ errors.customer_business_local }}</p></div>
                    </div>
                </div>
                <div class="field-state-dealer-app">
                    <div class="input-folder" style="padding-top: 0.5rem">
                        <div class="input-folder--input">
                            <InputText 
                                :aria-required="true" 
                                id="customer_business_private" v-model="customer_business_private"
                                :class="{'invalid-state-input': errors.customer_business_private != null}"
                                placeholder=" "
                                fluid
                            />
                            <label for="customer_business_private" :class="{'invalid-state': errors.customer_business_private}">
                                <p>Private *</p>
                            </label>
                        </div>
                        <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.customer_business_private">{{ errors.customer_business_private }}</p></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="props.conditionalSalesperson">
            <h3 class="headline-xs form-headline-dealer-app">Salesperson</h3>
            <div class="field-type-dealer-app-full-width">
                <div class="field-state-dealer-app">
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <InputText 
                                :aria-required="true" 
                                id="conditional_salesperson" v-model="conditional_salesperson"
                                :class="{'invalid-state-input': errors.conditional_salesperson != null}"
                                placeholder=" "
                                fluid
                            />
                            <label for="conditional_salesperson" :class="{'invalid-state': errors.customer_business_private}">
                                <p>Salesperson *</p>
                            </label>
                        </div>
                        <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.conditional_salesperson">{{ errors.conditional_salesperson }}</p></div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <h3 class="headline-xs form-headline-dealer-app">Company's Social Profiles</h3>
            <p class="invalid-state form-headline-dealer-app" v-if="errors.company_socials">{{ errors.company_socials}}</p>
            <div v-for="(social, index) in company_socials" :key="index">
                <p :id="`social_media_label_${index}`" class="title-s banner-title form-headline-dealer-app">Social Media {{index+1}}</p>
                <div class="field-type-dealer-app">
                    <div class="field-state-dealer-app">
                        <custom-select
                            :aria-required="true" 
                            v-model="social.digital_profile_type_obj"
                            label="Social Media Type *"
                            name="company_social_website" 
                            :id="`company_social_website_${index}`" 
                            aria-label="Enter Social Website"   
                            :options="formattedSocialOptions"
                            :error="errorsCompanySocialWebsiteExists(index) != null"
                        />
                        <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsCompanySocialWebsiteExists(index)">{{ errors[`company_socials[${index}].digital_profile_type`]  }}</p></div>
                    </div>
                    <div class="flex-row">
                        <div class="field-state-dealer-app input-folder" style="width: 100%">
                            <div class="input-folder--input">
                                <InputText 
                                    :aria-required="true" 
                                    :id="`company_social_url_${index}`" v-model="social.url"
                                    placeholder=" "
                                    :class="{'invalid-state': errorsCompanySocialURLExists(index)}"
                                    fluid
                                />
                                <label :for="`company_social_url_${index}`" :class="{'invalid-state': errorsCompanySocialURLExists(index)}">
                                    <p v-if="social.digital_profile_type != 'Web'">Handle *</p>
                                    <p v-else>URL *</p>
                                </label>
                            </div>
                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsCompanySocialURLExists(index)">{{ errors[`company_socials[${index}].url`]}}</p></div>
                        </div>
                        <div v-if="index != company_socials.length" class="mobile-hidden" :style="`align-content: center; padding-right: 1.25rem; ${errorsCompanySocialURLExists(index) || errorsCompanySocialWebsiteExists(index) ? 'padding-bottom: 1rem;' : ''}`">
                            <CloseIcon style="cursor: pointer;" @click="removeSocial(index)" />
                        </div>
                    </div>
                </div>
                <div v-if="index == company_socials.length-1" class="footer-button-container">
                    <RothcoCta type="button" @click="removeSocial(index)" class="primary desktop-hidden-flex" :id="`delete_button_${index}`">Delete</RothcoCta>
                    <RothcoCta type="button" @click="addSocial()" class="secondary" :id="`add_button_${index}`">Add Additional</RothcoCta>
                </div>
                <div v-else class="footer-button-container desktop-hidden-flex">
                    <RothcoCta type="button" @click="removeSocial(index)" class="primary desktop-hidden-flex" :id="`delete_button_${index}`">Delete</RothcoCta>
                </div>
            </div>
            <div v-if="company_socials.length == 0">
                <div class="footer-button-container">
                    <RothcoCta type="button" @click="addSocial(initialSocial)" class="primary">Add Social</RothcoCta>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, onMounted, unref, watch } from "vue";
    import RothcoCta from "./RothcoCta.vue";
    import InputText from "primevue/inputtext";
    import DatePicker from "@/components/DatePicker.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    let customer_date_founded = defineModel("customer_date_founded", {type: String, default: ''});
    let customer_employees = defineModel("customer_employees", {type: String, default: ''});
    let how_did_you_hear_about_rothco = defineModel("how_did_you_hear_about_rothco", {type: String, default: ''});
    let how_did_you_hear_about_rothco_details = defineModel("how_did_you_hear_about_rothco_details", {type: String, default: ''});
    let total_annual_sale = defineModel("total_annual_sale", {type: String, default: ''});
    let total_outside_sale = defineModel("total_outside_sale", {type: String, default: ''});
    let total_stores = defineModel("total_stores", {type: String, default: ''});
    let number_of_gov_contracts = defineModel("number_of_gov_contracts", {type: String, default: ''});
    let gov_websites = defineModel("gov_websites", {type: String, default: ''});
    let customer_business_federal = defineModel("customer_business_federal", {type: String, default: ''});
    let customer_business_state = defineModel("customer_business_state", {type: String, default: ''});
    let customer_business_local = defineModel("customer_business_local", {type: String, default: ''});
    let customer_business_private = defineModel("customer_business_private", {type: String, default: ''});
    let company_socials = defineModel("company_socials", {type: Array, default: []});
    let urls_featuring_rothco = defineModel("urls_featuring_rothco", {type: String, default: ''});
    let top_vendor_1 = defineModel("top_vendor_1", {type: String, default: ''});
    let top_vendor_2 = defineModel("top_vendor_2", {type: String, default: ''});
    let top_vendor_3 = defineModel("top_vendor_3", {type: String, default: ''});
    let sale_on_other_countries = defineModel("sale_on_other_countries", {type: Array<String>, default: []});
    let describe_end_user = defineModel("describe_end_user", {type: String, default: ''});
    let screenprint_embroider_logo = defineModel('screenprint_embroider_logo', {type: String, default: ''});
    let dealer_type = defineModel("dealer_type", {type: String, default: ''});
    let conditional_salesperson = defineModel("conditional_salesperson", {type: String, default: ''});

    let errors = defineModel("errors", {
        type: Object,
        default(){
            return {};
        }
    });

    let props = defineProps({
        countries: {
            type: Object,
            default(){
                return {};
            }
        },
        hideSource: {
            type: Boolean,
            default: false
        },
        conditionalSalesperson:{
            type: Boolean,
            default: false
        },
        socialOptions: {
            type: Array,
            default(){
                return [];
            }
        }
    })

    let formattedOutsideCountries = computed(() => {
        return Object.entries(props.countries).map(([key, value]) => {
            return {
                key: key,
                value: value
            };
        });
    });

    let initialSocial = ref({ digital_profile_type: '', url: '' });
    const customerEmployeesOptions = [
        { code: "self_employed", name: "Self-employed" },
        { code: "1_10_employees", name: "1-10 employees" },
        { code: "11_50_employees", name: "11-50 employees" },
        { code: "51_200_employees", name: "51-200 employees" },
        { code: "201_500_employees", name: "201-500 employees" },
        { code: "501_1000_employees", name: "501-1000 employees" },
        { code: "1001_employees", name: "1001+ employees" }
    ];
    let formattedCustomerEmployeesOptions = computed(()=>{
        return customerEmployeesOptions.map(option=>{
            return {
                key: option.code,
                value: option.name
            }
        })
    });
    let selectedCustomerEmployeeOption = computed({
        get(){
            return formattedCustomerEmployeesOptions.value.find(currentEmployeeOption => currentEmployeeOption.key == customer_employees.value) ?? {key: '', value: ''};
        },
        set(value){
            customer_employees.value = value.key;
        }
    });
    const totalAnnualSaleOptions = [
        { code: "customer_total_annual_sales_10k", name: "Less than $10K" },
        { code: "customer_total_annual_sales_25k", name: "$10K - $25K" },
        { code: "customer_total_annual_sales_75k", name: "$25K - $75K" },
        { code: "customer_total_annual_sales_100k", name: "$75K - $100K" },
        { code: "customer_total_annual_sales_500k", name: "$100K - $500K" },
        { code: "customer_total_annual_sales_1m", name: "$500K - $1M" },
        { code: "customer_total_annual_sales_5m", name: "$1M - $5M" },
        { code: "customer_total_annual_sales_10m", name: "More Than $5M" }
    ];
    let formattedTotalAnnualSaleOptions = computed(()=>{
        return totalAnnualSaleOptions.map(option=>{
            return {
                key: option.code,
                value: option.name
            }
        })
    });
    let selectedTotalAnnualSaleOption = computed({
        get(){
            return formattedTotalAnnualSaleOptions.value.find(currentTotalAnnualSaleOption => currentTotalAnnualSaleOption.key == total_annual_sale.value) ?? {key: '', value: ''};
        },
        set(value){
            total_annual_sale.value = value.key;
        }
    });
    const totalOutsideSaleOptions = [
        { code: "customer_export_sales_0_perc", name: "0%" },
        { code: "customer_export_sales_5_perc", name: "0-5%" },
        { code: "customer_export_sales_25_perc", name: "5-25%" },
        { code: "customer_export_sales_50_perc", name: "25-50%" },
        { code: "customer_export_sales_100_perc", name: "More than 50%" }
    ];
    let formattedTotalOutsideSaleOptions = computed(()=>{
        return totalOutsideSaleOptions.map(option=>{
            return {
                key: option.code,
                value: option.name
            }
        })
    });
    let selectedTotalOutsideSaleOption = computed({
        get(){
            return formattedTotalOutsideSaleOptions.value.find(currentTotalOutsideSaleOption => currentTotalOutsideSaleOption.key == total_outside_sale.value) ?? {key: '', value: ''};
        },
        set(value){
            total_outside_sale.value = value.key;
        }
    });
    const numberOfGovContractsOptons = [
        { code: "0", name: "0" },
        { code: "5", name: "1-5" },
        { code: "10", name: "6-10" },
        { code: "11", name: ">10" }
    ];
    let formattedNumberOfGovContractsOptions = computed(()=>{
        return numberOfGovContractsOptons.map(option=>{
            return {
                key: option.code,
                value: option.name
            }
        })
    });
    let selectedNumberOfGovContractsOption = computed({
        get(){
            return formattedNumberOfGovContractsOptions.value.find(currentNumberOfGovContractsOption => currentNumberOfGovContractsOption.key == number_of_gov_contracts.value) ?? {key: '', value: ''};
        },
        set(value){
            number_of_gov_contracts.value = value.key;
        }
    });
    const howDidYouHearAboutRothcoOptions = [
        { code: "GOOG", name: "Google Ads" },
        { code: "RWP", name: "Web Search (Rothco Web Page)" },
        { code: "CUS", name: "Rothco Dealer Referral" },
        { code: "VEN", name: "Vendor Referral (Rothco Dealer)" },
        { code: "ALF", name: "Vendor Referral (Other)" },
        { code: "trade_show", name: "Trade Show" },
        { code: "social", name: "Social Network" },
        { code: "PROD", name: "Product Label / Tag" },
        { code: "CON", name: "Consumer Referral" },
        { code: "trade_organization", name: "Trade Organization" },
        { code: "other", name: "Other" }
    ];
    let formattedHowDidYouHearAboutRothcoOptions = computed(()=>{
        return howDidYouHearAboutRothcoOptions.map(option=>{
            return {
                key: option.code,
                value: option.name
            }
        })
    });
    let selectedHowDidYouHearAboutRothcoOption = computed({
        get(){
            return formattedHowDidYouHearAboutRothcoOptions.value.find(currentHowDidYouHearAboutRothcoOption => currentHowDidYouHearAboutRothcoOption.key == how_did_you_hear_about_rothco.value) ?? {key: '', value: ''};
        },
        set(value){
            how_did_you_hear_about_rothco.value = value.key;
        }
    });
    let howDidYouHearAboutRothcoDetailsOptions = computed(()=>{
        switch(how_did_you_hear_about_rothco.value){
            case "trade_organization":
                return [
                    { key: "23", value: "ASI" },
                    { key: "ESP", value: "ESP" },
                    { key: "PPAI", value: "PPAI" },
                    { key: "SAGE", value: "Sage" }
                ]
            case "trade_show":
                return [
                    { key: "30", value: "SHOT" },
                    { key: "ANME", value: "ANME" },
                    { key: "ISS", value: "ISS Long Beach" },
                    { key: "9", value: "Project/Magic Spring" },
                    { key: "9A", value: "Project/Magic Fall" }
                ]
            case "social":
                return [
                    { key: "FB", value: "Facebook" },
                    { key: "INST", value: "Instagram" },
                    { key: "LINK", value: "Linkedin" },
                    { key: "YTE", value: "Youtube" },
                    { key: "TKT", value: "Tiktok" },
                    { key: "TWT", value: "X" }
                ];
            default: 
                return;
        }
    });
    let selectedHowDidYouHearAboutRothcoDetailsOption = computed({
        get(){
            return howDidYouHearAboutRothcoDetailsOptions.value?.find(currentHowDidYouHearAboutRothcoDetailsOption => currentHowDidYouHearAboutRothcoDetailsOption.key == how_did_you_hear_about_rothco_details.value) ?? {key: '', value: ''};
        },
        set(value){
            how_did_you_hear_about_rothco_details.value = value.key;
        }
    });

    let formattedSocialOptions = computed(()=>{
        return props.socialOptions.map(option=>{
            return {
                key: option.code,
                value: option.name
            }
        })
    });
    
    function errorsCompanySocialWebsiteExists(index){
        return errors.value[`company_socials[${index}].digital_profile_type`];
    }
    function errorsCompanySocialURLExists(index){
        return errors.value[`company_socials[${index}].url`];
    }

    function addSocial(social=null) {
        if(social){
            let newSocial = JSON.parse(JSON.stringify({
                ...social, 
                digital_profile_type_obj: selectedInitialDigitalProfileType.value
            }))
            company_socials.value = [
                newSocial
            ]
            initialSocial.value = { digital_profile_type: '', url: '' };
        } else {
            company_socials.value = [...company_socials.value, {
                digital_profile_type: '',
                digital_profile_type_obj: {key: '', value: ''},
                url: '',
            }];
        }
    }

    let selectedInitialDigitalProfileType = computed({
        get(){
            return formattedSocialOptions.value?.find(currentSocialOption => currentSocialOption.key == initialSocial.value.digital_profile_type) ?? {key: '', value: ''};
        },
        set(val){
            initialSocial.value.digital_profile_type = val.key
        }
    })

    watch(()=>company_socials.value, (newVal, oldVal) => {
        const updatedSocials = newVal.map(val => {
            return {
                ...val,
                digital_profile_type: val.digital_profile_type_obj.key
            };
        });
        if (JSON.stringify(updatedSocials) !== JSON.stringify(oldVal)) {
            company_socials.value = updatedSocials;
        }
    }, {
        deep: true
    });

    function removeSocial(index) {
        let socials = JSON.parse(JSON.stringify(company_socials.value))
        socials.splice(index, 1);
        company_socials.value = socials;
    }

    let saleOnOtherCountries = ref([]);

    const requireSaleOnOtherCountries = computed(()=>{
        return !!total_outside_sale.value && total_outside_sale.value !== 'customer_export_sales_0_perc'
    })

    watch(() => saleOnOtherCountries.value, (newVal) => {
        sale_on_other_countries.value = newVal.map(v=>v?.key ?? '');
    }, {
        deep: true
    });

    let topVendors = ref([]);

    watch(() => topVendors.value, (newVal) => {

        top_vendor_1.value = newVal[0]?.key ?? '';
        top_vendor_2.value = newVal[1]?.key ?? '';
        top_vendor_3.value = newVal[2]?.key ?? '';
    }, {
        deep: true
    });
</script>
<style scoped lang="scss">
.footer-button-container {
    display: flex; 
    justify-content: center; 
    padding: 1.25rem;
    gap: 1.25rem;
}
</style>